import React, { useState } from 'react'
import { useRecoilValue } from 'recoil'

import float_btn from '@/assets/main/main_up_btn.png'
import Main1Section from '@/features/main/componentes/Main1Section'
import Main2Section from '@/features/main/componentes/Main2Section'
import Main3Section from '@/features/main/componentes/main3Section'
import Main4Section from '@/features/main/componentes/Main4Section'
import Main5Section from '@/features/main/componentes/Main5Section'
import Main6Section from '@/features/main/componentes/Main6Section'
import Main7Section from '@/features/main/componentes/Main7Section'
import Main8Section from '@/features/main/componentes/Main8Section'
import Main9Section from '@/features/main/componentes/Main9Section'
import Popup from '@/shared/components/common/Popup'
import { APP_STORE_WARD, IOS_APP_STORE_WARD, MO_APP_STORE_WARD } from '@/shared/constant/url'
import useWindowDimensions from '@/shared/hooks/useGetWindowSize'
import { useScroll } from '@/shared/hooks/useScroll'
import { MoHeaderMenuToggle } from '@/shared/store'
import { deviceDetection } from '@/shared/utils'
import { MainMoFloatBtn, MainPcFloatBtn, MainWrap } from '@/styles/views/Main'

const Main = () => {
  const scrollup = useScroll()
  const [moFloatBtn, setMoFloatBtn] = useState(false)
  const [pcFloatBtn, setPcFloatBtn] = useState(false)
  const { width } = useWindowDimensions()
  const menuToggle = useRecoilValue(MoHeaderMenuToggle)

  const onClickAppDownload = () => {
    switch (deviceDetection()) {
      case 'AOS':
        window.open(width > 1200 ? APP_STORE_WARD : MO_APP_STORE_WARD)
        break
      case 'IOS':
        window.open(IOS_APP_STORE_WARD)
        break
    }
  }

  window.addEventListener('scroll', function () {
    if (window.scrollY > 2120) {
      setPcFloatBtn(true)
    } else {
      setPcFloatBtn(false)
    }
    if (window.scrollY > 0) {
      setMoFloatBtn(true)
    } else {
      setMoFloatBtn(false)
    }
  })

  /*20231024 lgu+ 가입/해지 불가 모달*/
  /*const {flag} = useNoticeModal("2023-10-16 00:00:00", "2023-10-23 08:00:00")
    const [open, setOpen] = useState(true)
    useEffect(() => {
        if (open && flag()) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'unset'
        }
    }, [open, flag])*/
  return (
    <MainWrap>
      <Popup />
      {/*20231024 lgu+ 가입/해지 불가 모달*/}
      {/*{flag() && <Modal isOpen={open} toggle={() => setOpen(!open)} type={'notice'} ClickFunc={() => setOpen(!open)}/>}*/}
      <Main1Section />
      <Main2Section />
      <Main3Section />
      <Main4Section />
      <Main5Section />
      <Main6Section />
      <Main7Section />
      <Main8Section />
      <Main9Section />
      {width > 1200 ? (
        <>{pcFloatBtn && <MainPcFloatBtn src={float_btn} onClick={scrollup.scrollTop} />}</>
      ) : (
        <MainMoFloatBtn
          active={`${!menuToggle && moFloatBtn && 'active'}`}
          onClick={onClickAppDownload}
        >
          <span>앱 설치하기</span>
        </MainMoFloatBtn>
      )}
    </MainWrap>
  )
}
export default Main
